import { AppState } from '../../../types/store';

export const loadingSelector = (state: AppState) => state.loading;
export const loadingUserEffectsSelector = (state: AppState) => state.loading.effects.user;
export const loadingDeliveriesEffectsSelector = (state: AppState) => state.loading.effects.deliveries;
